

































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DownlineHistoryBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly historyPage!: number;

  @Prop() readonly reportCurrency!: string;

  @Prop() readonly currencyRate!: object;

  @Prop() readonly showFilterCurrency!: boolean;

  calRate(value: number) {
    return (value / this.currencyRate[this.reportCurrency]);
  }
}
